import React from 'react';
import { Redirect, Route } from 'react-router';

import SignUp from './SignUp';

const SignUpRoutes = () => {
    return (
        <>
            <SignUp />
            <Route exact path="/signup/general">
                <Redirect to="/signup/business" />
            </Route>
            <Route
                exact
                path="/signup/business/pricing"
                component={({ location }) => (
                    <Redirect
                        to={{
                            ...location,
                            pathname: '/signup/business'
                        }}
                    />
                )}
            />
        </>
    );
};

export default SignUpRoutes;
